export default __webpack_public_path__ + "static/media/wallet_active.2143f89b.svg";